import { useBrToast } from '@/composables/useBrToast';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('vue:error', (error) => {
        const toast = useBrToast();

        // error was not thrown with createError();
        if (!isNuxtError(error)) {
            return;
        }

        if (error.fatal) {
            return;
        }

        toast.errorToast(error.statusText || 'An error occurred', getAllErrorMessages(error)[0] ?? 'Unknown error');

        clearError();
    });
});
